import { render, staticRenderFns } from "./SkupSuorganizatorDetails.vue?vue&type=template&id=d90fa148&scoped=true&"
import script from "./SkupSuorganizatorDetails.vue?vue&type=script&lang=js&"
export * from "./SkupSuorganizatorDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d90fa148",
  null
  
)

export default component.exports